import { lazy } from 'react';

const Menu = lazy(() => import('./Menu'));

export { Menu };
